/**
 * The solar storefront identity. Keep the owner-controlled name here and in
 * the template shell fill; block copy must remain reusable across tenants.
 */
export const BRAND_NAME = 'Allow Energy';
export const THEME_ID = 'solar-pv';
export const TEMPLATE_KEY = 'solar-pv';

/** The standalone solar designer is intentionally outside storefront routing. */
export const DESIGNER_HREF = '/solar/planner/';
export const QUICK_QUOTE_HREF = '/solar/planner/quick';
export const MY_DESIGNS_HREF = '/solar/planner/my';

export const DESIGNER_PLACEHOLDER = '[confirm]';
export const GUARANTEE_PLACEHOLDER = '[confirm]';
export const DELIVERY_PLACEHOLDER = '[confirm]';

export const BRAND = {
  name: BRAND_NAME,
  domain: 'allowenergy.com',
} as const;

export default BRAND;
